<template>
    <div class="flex flex-col bg-gray-50 p-3 h-full">
        <h3 class="font-bold">{{ $t('orders.documents') }}</h3>
        <div class="flex mt-2 flex-col">
            <span v-for="note in deliveryNotes" :key="note.id">
                 <span class="font-mono mt-2 cursor-pointer" @click="download(note)">{{ cut(note.name) }}</span>
            </span>
        </div>

    </div>

</template>

<script>

import {EnvelopeIcon, PhoneIcon} from "@heroicons/vue/24/outline";
import LinkButton from "@/Jetstream/LinkButton";
import {downloadFile} from "@/Shared/Utils/downloader";

export default {
    props: ['deliveryNotes', 'order'],
    components: {
        LinkButton,
        EnvelopeIcon,
        PhoneIcon
    },
    methods: {
        download(note) {
            downloadFile(this.route("sales.orders.deliveryNotes.download", {
                order: this.order.id,
                deliveryNote: note.id
            }), note.name);
        },
        cut(name) {
            if (!name) {
                return '';
            }

            if (name.length > 35) {
                return name.substr(0, 35) + "\u2026";
            }

            return name;
        }
    },
}
</script>

<style scoped>

</style>
